// @ts-nocheck

import React, { memo, useContext, ReactNode, useCallback } from "react";

import LabelTextItem from "../../LabelTextItem";
import TextFieldComponent from "./TextField";
import { FormContext, useFormField } from "../../Form";
import { TextFieldProps } from "./TextField.props";

/**
 * @deprecated Use `import { Textbox } from capitalrx-components-2.0/lib/forms` instead.
 */
const TextField: React.FC<TextFieldProps> = (props: TextFieldProps): JSX.Element => {
  const { id, labelText, name, displayReadOnlyFieldInline, readOnly, shouldHide, defaultValue, type, formatValue = "", isLoading } = props;
  const formContextValues = useContext(FormContext);

  let component = null;

  const fieldValue = useFormField(name || "");

  const shouldHideHandler = useCallback((value: ReactNode): boolean => {
    if (shouldHide) {
      if (value === undefined) return shouldHide(undefined);
      if (typeof value === "string") return shouldHide(value);
    }

    return false;
  }, []);

  if (formContextValues.readOnly || readOnly) {
    const textFieldValue = fieldValue && new Array(String(fieldValue)).filter(Boolean).join("\r\n");

    component = (
      <LabelTextItem
        id={id}
        label={labelText}
        displayInline={displayReadOnlyFieldInline}
        body={textFieldValue || defaultValue}
        isLoading={formContextValues.formState.isFormLoading || isLoading}
        shouldHide={shouldHideHandler}
        className={props?.containerClassName}
        type={type}
        formatValue={formatValue}
      />
    );
  } else {
    component = <TextFieldComponent {...props} {...formContextValues} />;
  }

  return component;
};

/**
 * @deprecated
 */
export default memo(TextField);
